import { ConfirmDialog, LinearProgress, Typography } from '@occc-app/design-system';
import { Box } from '@mui/material';

export const CopyConfirmDialog = ({
  open,
  loading,
  componentName,
  onClose,
  onConfirm,
}: {
  open: boolean;
  loading: boolean;
  componentName: string;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <ConfirmDialog
      dialogTitle={`Copy ${componentName}`}
      open={open}
      onClose={onClose}
      confirmButtonText='Copy'
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: loading,
      }}
    >
      <Box mb={1}>{loading ? <LinearProgress /> : <Box height={2} />}</Box>
      <Typography variant='body1'>{`Are you sure that you want to copy ${componentName}?`}</Typography>
    </ConfirmDialog>
  );
};
